import moment from "moment";

export function sortStudies(studies, sort) {

  const sortFieldName = sort.fieldName || 'PatientName';
  const sortDirection = sort.direction || 'desc';

  // For our smaller displays, map our field name to a single
  // field we can actually sort by.
  const sortFieldNameMapping = {
    allFields: 'PatientName',
    patientNameOrId: 'PatientName',
    accessionOrModalityOrDescription: 'modalities',
  };
  const mappedSortFieldName = sortFieldNameMapping[sortFieldName] || sortFieldName;

  const sortedStudies = _sortStudies(studies, mappedSortFieldName, sortDirection);

  return sortedStudies;
}

/**
 *
 *
 * @param {object[]} studies - Array of studies to sort
 * @param {string} studies.StudyDate - Date in 'MMM DD, YYYY' format
 * @param {string} field - name of properties on study to sort by
 * @param {string} order - 'asc' or 'desc'
 * @returns
 */
function _sortStudies(studies, field, order) {
  // Make sure our StudyDate is in a valid format and create copy of studies array
  const sortedStudies = [...studies];

  // Sort by field
  sortedStudies.sort((a, b) => {
    let fieldA = a[field];
    let fieldB = b[field];

    if (field === 'StudyDate') {
      fieldA = moment(fieldA).toISOString();
      fieldB = moment(fieldB).toISOString();
    }

    // Order
    if (order === 'desc') {
      if (fieldA < fieldB) {
        return -1;
      }
      if (fieldA > fieldB) {
        return 1;
      }
      return 0;
    }
    if (fieldA > fieldB) {
      return -1;
    }
    if (fieldA < fieldB) {
      return 1;
    }
    return 0;
  });

  const formatedSortedStudies = sortedStudies.map((study) => {
    if (!moment(study.StudyDate, 'MMM DD, YYYY', true).isValid()) {
      study.StudyDate = moment(study.StudyDate, 'YYYYMMDD').format('MMM DD, YYYY');
    }
    return study;
  });

  return formatedSortedStudies;
}
